export interface SisResponse {
  success: boolean;
  message?: string;
  code?: string;
  statusCode?: number;
}
export interface BatchSisResponse extends SisResponse {
  transcriptId?: string;
}
export const SisErrorCodes = {
  // Data validation errors
  DATA_VALIDATION: 'DATA_VALIDATION_EXCEPTION',

  // Not found errors
  STUDENT_NOT_FOUND: 'STUDENT_NOT_FOUND_EXCEPTION',
  INSTITUTION_NOT_FOUND: 'INSTITUTION_NOT_FOUND_EXCEPTION',

  // System/infrastructure errors
  SIS_UNAVAILABLE: 'SIS_UNAVAILABLE',
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  CONFIGURATION_ERROR: 'CONFIGURATION_ERROR',

  // Connect errors
  CONNECT_DOWN: 'CONNECT_DOWN',
  SOURCE_INACTIVE: 'SOURCE_INACTIVE',
  SOURCE_NOT_MAPPED: 'SOURCE_NOT_MAPPED',

  PARTIAL_COURSE_UPLOAD_FAILURE: 'PARTIAL_COURSE_UPLOAD_EXCEPTION',

  MULTIPLE_STUDENTS_MATCHED: 'TOO_MANY_STUDENT_MATCHES_EXCEPTION',
  MULTIPLE_INSTITUTIONS_MATCHED: 'TOO_MANY_INSTITUTION_MATCHES_EXCEPTION',

  // Generic
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
} as const;

export type SisErrorCode = (typeof SisErrorCodes)[keyof typeof SisErrorCodes];
